import * as actionTypes from './actionTypes';

export const getCampaignsRequest = (payload) => ({ type: actionTypes.CAMPAIGNS_GET_LIST_REQUEST, payload });
export const getCampaignsError = (payload) => ({ type: actionTypes.CAMPAIGNS_GET_LIST_ERROR, payload });
export const getCampaignsStore = (payload) => ({ type: actionTypes.CAMPAIGNS_GET_LIST_STORE, payload });

export const loadMoreCampaignsRequest = () => ({ type: actionTypes.CAMPAIGNS_LOAD_MORE_REQUEST });
export const loadMoreCampaignsError = (payload) => ({ type: actionTypes.CAMPAIGNS_LOAD_MORE_ERROR, payload });
export const loadMoreCampaignsStore = (payload) => ({ type: actionTypes.CAMPAIGNS_LOAD_MORE_APPEND, payload });

export const getSingleCampaignRequest = (payload) => ({ type: actionTypes.CAMPAIGNS_GET_SINGLE_REQUEST, payload });
export const getSingleCampaignError = (payload) => ({ type: actionTypes.CAMPAIGNS_GET_SINGLE_ERROR, payload });
export const getSingleCampaignStore = (payload) => ({ type: actionTypes.CAMPAIGNS_GET_SINGLE_STORE, payload });

export const removeFromList = (payload) => ({ type: actionTypes.CAMPAIGNS_REMOVE_FROM_LIST, payload });
export const setRequesting = (payload) => ({ type: actionTypes.SET_REQUESTING, payload });
